import { customerPill } from '@visionqc/shared';

/**
 * Who owns this — a tinted pill with the customer's name in it.
 *
 * The name is inside the pill, not beside a coloured dot, and that is the
 * whole design rather than a styling choice: the text carries identity, so the
 * tint never has to be decoded. See packages/shared/src/customerColors.ts for
 * the measurements — as an encoding, colour caps at three customers on this
 * surface; as a tint behind a name it does not cap at all.
 */
export function CustomerPill({
  name,
  hue,
  title,
}: {
  name: string | null | undefined;
  hue: number | null | undefined;
  title?: string;
}) {
  const c = customerPill(name ? hue : null);
  return (
    <span
      title={title ?? (name ? `Owned by ${name}` : 'No customer')}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: '3px 10px',
        borderRadius: 999,
        background: c.background,
        color: c.text,
        border: `1px solid ${c.border}`,
        fontSize: 12,
        fontWeight: 600,
        lineHeight: 1.5,
        whiteSpace: 'nowrap',
        maxWidth: 220,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }}
    >
      {name ?? 'No customer'}
    </span>
  );
}
